<template>
  <v-row class="pt-3">
    <v-col cols="12" md="12">
      <div class="text-subtitle-1 font-weight-bold">Upload images</div>
    </v-col>
    <v-col cols="12" md="12" class="ml-1 py-0">
      <AddNewImage
        v-if="currentEvent.coverImageURL == ''"
        :applyDashedBorder="true"
        :isRectangle="true"
        :width="510.3"
        :height="337.5"
        text="Upload cover image"
        @click="showUploadCoverImageDialog = true"
        color="white"
      />
      <v-hover v-slot="{ hover }" v-else>
        <v-sheet width="567" height="375">
          <v-img
            style="width: 567px; height: 375px"
            width="567"
            height="375"
            class="rounded-lg outlined-border"
            :src="currentEvent.coverImageURL"
          >
            <div class="text-right mt-2 mr-2" v-show="hover">
              <AvatarButton
                icon="mdi-image"
                tooltipText="Change image"
                @click="showUploadCoverImageDialog = true"
                className="d-inline-block mr-2"
              />

              <AvatarButton
                icon="mdi-trash-can"
                tooltipText="Delete image"
                @click="currentEvent.coverImageURL = ''"
                className="d-inline-block"
              />
            </div>
          </v-img>
        </v-sheet>
      </v-hover>

      <div
        class="d-flex flex-wrap justify-start align-center"
        v-if="eventCategory == 'multiConnect'"
      >
        <div v-if="currentEvent.displayImageURL" class="mt-n16 ml-8">
          <!-- class="d-flex align-center" -->
          <v-hover v-slot="{ hover }">
            <v-sheet
              class="circle d-flex justify-center align-center"
              width="140"
              height="140"
              outlined
            >
              <v-img
                :src="currentEvent.displayImageURL"
                class="circle"
                width="137"
                height="137"
              >
                <div class="text-center mt-2" v-show="hover">
                  <AvatarButton
                    icon="mdi-image"
                    tooltipText="Change image"
                    @click="showUploadImageDialog = true"
                    className="d-inline-block mr-2"
                  />

                  <AvatarButton
                    icon="mdi-trash-can"
                    tooltipText="Delete image"
                    @click="currentEvent.displayImageURL = ''"
                    className="d-inline-block"
                  />
                </div>
              </v-img>
            </v-sheet>
          </v-hover>
        </div>

        <div v-else class="mt-n16 ml-8">
          <AddNewImage
            :applyDashedBorder="true"
            :size="140"
            text="Upload image"
            :isCircle="true"
            @click="showUploadImageDialog = true"
            :zIndex="2"
            cssPosition="relative"
            color="white"
          />
        </div>
      </div>
      <p
        v-if="
          eventCategory == 'multiConnect' &&
          displayImageURLError &&
          this.currentEvent.displayImageURL == ''
        "
        class="error--text"
      >
        Logo is required
      </p>
      <UploadImageDialog
        :show="showUploadCoverImageDialog"
        isDisplayImage
        previewType="rectangle"
        ref="uploadCoverImageDialog"
        @close="showUploadCoverImageDialog = false"
        @uploaded="handleCoverImageUploaded"
        :uploadToBusinessProfile="false"
        :generateCompressedImage="true"
        @compressed-image-uploaded="handleCompressedImageUploaded"
      />

      <UploadImageDialog
        :show="showUploadImageDialog"
        isDisplayImage
        previewType="displayImageURL"
        @close="showUploadImageDialog = false"
        @uploaded="handleUploaded"
        :uploadToBusinessProfile="false"
      />
    </v-col>
  </v-row>
</template>

<script>
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import AvatarButton from "@/components/AvatarButton";
import { mapGetters } from "vuex";

export default {
  props: {
    eventCategory: { type: String, default: "multiConnect" },
  },
  computed: {
    ...mapGetters(["currentEvent", "currentSubEvent"]),
  },
  components: {
    AddNewImage,
    AvatarButton,
    UploadImageDialog,
  },
  created() {
    if (this.eventCategory == "multiConnect")
      this.selectedEvent = this.currentEvent;
    else if (this.eventCategory == "subEvent")
      this.selectedEvent = this.currentSubEvent;
  },
  data() {
    return {
      showUploadCoverImageDialog: false,
      showUploadImageDialog: false,
      displayImageURLError: false,
      selectedEvent: null,
    };
  },
  mounted() {
    this.$emit("validatePage", "UploadImages", this);
  },
  methods: {
    async handleCoverImageUploaded(downloadURL) {
      this.currentEvent.coverImageURL = downloadURL;
    },
    handleCompressedImageUploaded(compressedImageDownloadURL) {
      console.log("compressedImageDownloadURL: ", compressedImageDownloadURL);
      this.currentEvent.compressedCoverImageURL = compressedImageDownloadURL;
    },
    async handleUploaded(downloadURL) {
      this.currentEvent.displayImageURL = downloadURL;
    },
    validatePage() {
      if (this.currentEvent.displayImageURL) return true;
      else {
        this.displayImageURLError = true;
        return false;
      }
    },
  },
};
</script>

<style>
</style>